// CANONICAL COPY (GH #7115). src/constants/obligations/obl-offsite-asset-security.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-offsite-asset-security',
  title: 'Verify security of assets used off-premises',
  description:
    'Confirm that assets used outside organisational premises — laptops, mobile devices, removable media, home-office equipment and equipment used at customer sites — are protected with appropriate controls taking into account the additional risks of working outside secure premises. Controls shall include physical protection (cable locks, lockable storage), tamper evidence where relevant, insurance coverage where applicable, approval for off-site use, and return / accountability procedures. Review the off-site asset standard and records of off-site equipment authorisations.',
  category: 'assets',
  scfIds: ['SCF-PHY-009'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Off-site asset security standard is published' },
    { type: 'document-within-sla', description: 'Standard review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
